import {ROLE_DISPLAY_VALUES } from "../../constants";

const EmployeeRoles = ({ roles }) => {
  return roles
    ? roles.reduce((acc, role) => {
        if (role in ROLE_DISPLAY_VALUES) {
          return [...acc, role];
        }
        return acc;
      }, [])
    : [];
};

export default EmployeeRoles;
